<template>
  <div class="location-map" :class="getActiveClass">
    <div style="width: 100%;height: 50vh;min-height: 650px;" class="map"></div>
    <div class="infowindow-current-location">
      <span id="place-name" class="title">CURRENT LOCATION</span><br />
      <span id="place-address"></span>
    </div>
    <div class="infowindow-practice-location">
      <div id="place-name" class="title"></div>
      <div id="place-address"></div>
      <div id="place-xmilesaway"></div>
      <div id="place-nextappointment"></div>
      <div class="button-wrapper"><button class="btn" @click="onSelectPractice" title="Click to toggle the selection" v-show="getSelectButtonLabel !== ''">{{ getSelectButtonLabel }}</button></div>
    </div>
  </div>
</template>

<script>
/*global google*/
/*global jQuery*/
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";

//init gMapLoader for using GoogleMap library
const gMapLoader = new Loader({
  apiKey: window.wpGmap.gmap_api_key,
  version: "weekly",
  libraries: ["places"]
});

const ICON_GROUP = "/app/themes/leightons/images/map-marker-group.png";
const ICON_PRACTICE_LOCATION = "/app/themes/leightons/images/location-marker.png";
const ICON_CURRENT_LOCATION = "/app/themes/leightons/images/current-location-marker.png";
const OVERALL_ZOOM = 7;
const SEARCH_ZOOM = 10;
const VIEW_ZOOM = 12;

export default {
  name: "BookingLocationMap",
  emits: ["onShowMore", "onSelect", "onLocationCordChanged", "onLocationCordReset"],
  props: [
    "appointment",
    "displayed_practices",
    "all_practices",
    "user_location_cord",
    "pagination",
    "visibilityChanged"
  ],
  data () {
    return {
      active_practice: null,
    }
  },
  watch: {
    visibilityChanged(newValue) {
      if (newValue) {
        if (this.appointment.practice.ID !== 0) {
          this.active_practice = this.appointment.practice;
          this.zoomToActivePractice();
        } else if (this.user_location_cord) {
          this.zoomToActiveUserCord();
        }
      }
    },
    all_practices() {
      if (typeof (google) != 'undefined') { // make sure goolge has been already loaded
        this.onAllPracticesChanged();
      }
    }
  },
  methods: {

    onSelectPractice() {
      if (this.getSelectButtonLabel === "Select practice" ) {
        this.$emit("onSelect", this.active_practice);
      } else {
        this.$emit("onSelect", null);
      }
    },

    zoomToActivePractice() {
      const thisView = this;
      const feature = this.active_practice;
      const [lat,lng] = feature.ad_latlng.split(",");
      const makerLocation = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
      };
      const mile_away = feature.distance;
      let mile_away_str = "";
      if (mile_away > -1 && mile_away < 99999) {
        mile_away_str = `${mile_away } ${ mile_away > 1 ? "miles" : "mile" } away`;
      }
      thisView.infowindowPracticeLocationContent.children["place-name"].innerHTML = feature.post_title;
      thisView.infowindowPracticeLocationContent.children["place-xmilesaway"].innerHTML = mile_away_str;
      thisView.infowindowPracticeLocationContent.children["place-address"].innerHTML = feature.ad_address;
      thisView.infowindowPracticeLocationContent.children["place-nextappointment"].innerHTML = feature.next_appointment_info;
      thisView.infowindow.setContent(thisView.infowindowPracticeLocationContent);
      thisView.infowindow.setPosition(makerLocation);
      thisView.infowindow.setOptions({
        pixelOffset: new google.maps.Size(0, -50)
      });
      thisView.infowindow.open(thisView.map);
      //zoom to the active practice
      thisView.map.setZoom(VIEW_ZOOM);
      thisView.map.setCenter(makerLocation);
    },

    zoomToActiveUserCord() {
      const thisView = this;
      if (thisView.user_location_cord && thisView.currentLocationMarker) {
        //thisView.map.setZoom(VIEW_ZOOM);
        thisView.map.setCenter(thisView.user_location_cord);
        thisView.currentLocationMarker.setVisible(true);
        thisView.currentLocationMarker.setPosition(thisView.user_location_cord);
        // thisView.infowindowCurrentLocationContent.children["place-address"].innerHTML = '';
        thisView.infowindow.setContent(thisView.infowindowCurrentLocationContent);
        thisView.infowindow.setOptions({
          pixelOffset: new google.maps.Size(0, -10)
        });
        // thisView.infowindow.open(thisView.map, thisView.currentLocationMarker);
      }
    },

    renderMap() {
      const thisView = this;
      const element = document.querySelector(".location-map");
      const start_point = this.user_location_cord;
      const mapOptions = {
        center: start_point ?? {
          lat: 52.4141923,
          lng: -1.8441743
        },
        zoom: OVERALL_ZOOM,
        disableDefaultUI: true
      };

      gMapLoader.load()
        .then((google) => {
          thisView.map = new google.maps.Map(element.querySelector(".map"), mapOptions);
          thisView.infowindow = new google.maps.InfoWindow();
          thisView.infowindowCurrentLocationContent = element.querySelector(".infowindow-current-location");
          thisView.infowindowPracticeLocationContent = element.querySelector(".infowindow-practice-location");

          const searchInput = document.querySelector("#booking-location-search-input");
          if (searchInput) {
            const autocomplete = this.initAutocomplete(searchInput);
            thisView.registerAutoCompleteChanged(searchInput, autocomplete);
          }

          thisView.renderMarkers();
          thisView.hideInfoWindowOnTappingOutside();
        });
    },

    renderMarkers() {
      const currentMarkers = this.getMarkers(this.all_practices);
      this.initMarkerClusterer(this.map, currentMarkers);
    },

    initMarkerClusterer(map, markers) {
      if (this.markerClusterer == null) {
        const renderer = {
          render: ({ count, position }) => {
            const clusterMarker = new google.maps.Marker({
              label: { text: String(count), color: "white", fontSize: "20px", },
              position,
              zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
              icon: {
                url: ICON_GROUP,
                scaledSize: new google.maps.Size(35, 62),
              }
            });
            return clusterMarker;
          },
        };
        var styles = [{
          height: 4,
        }];
        this.markerClusterer = new MarkerClusterer({ map, markers, renderer, styles });
      } else {
        this.markerClusterer.clearMarkers(true);
        this.markerClusterer.addMarkers(markers, false);
      }
    },

    getMarkers(googlemap_posts) {
      // Loop through the map data and initialise a google marker object
      const thisView = this;
      if (!thisView.markersPool) {
        thisView.markersPool = [];
      }
      const markers = googlemap_posts.map(feature => {
        // Google marker object
        const [lat,lng] = feature.ad_latlng.split(",");
        const makerLocation = {
          lat: parseFloat(lat),
          lng: parseFloat(lng)
        };
        const marker = new google.maps.Marker({
          position: makerLocation,
          icon: ICON_PRACTICE_LOCATION,
          class: "",
          map: thisView.map
        });

        // Add event listener to the google marker
        marker.addListener("click", (event) => {
          const mile_away = feature.distance;
          let mile_away_str = "";
          if (mile_away > -1 && mile_away < 99999) {
            mile_away_str = `${mile_away } ${ mile_away > 1 ? "miles" : "mile" } away`;
          }
          thisView.infowindowPracticeLocationContent.children["place-name"].innerHTML = feature.post_title;
          thisView.infowindowPracticeLocationContent.children["place-xmilesaway"].innerHTML = mile_away_str;
          thisView.infowindowPracticeLocationContent.children["place-address"].innerHTML = feature.ad_address;
          thisView.infowindowPracticeLocationContent.children["place-nextappointment"].innerHTML = feature.next_appointment_info;
          thisView.infowindow.setContent(thisView.infowindowPracticeLocationContent);
          thisView.infowindow.setPosition(event.latLng);
          thisView.infowindow.setOptions({
            pixelOffset: new google.maps.Size(0, -50)
          });
          thisView.infowindow.open(thisView.map);
          //zoom to the active practice
          thisView.map.setZoom(VIEW_ZOOM);
          thisView.map.setCenter(event.latLng);
          thisView.active_practice = feature;
        });

        thisView.markersPool.push({
          id: feature.ad_location_id,
          marker: marker
        });

        return marker;
      });
      return markers;
    },

    initAutocomplete(input) {
      const options = {
        componentRestrictions: { country: "uk" },
        fields: ["formatted_address", "geometry", "place_id", "name"],
      };
      const autocomplete = new google.maps.places.Autocomplete(input, options);
      return autocomplete;
    },

    registerAutoCompleteChanged(input, autocomplete) {
      const thisView = this;
      const geocoder = new google.maps.Geocoder();

      thisView.currentLocationMarker = new google.maps.Marker({
        map: thisView.map,
        icon: ICON_CURRENT_LOCATION
      });
      thisView.currentLocationMarker.addListener("click", () => {
        thisView.infowindow.setContent(thisView.infowindowCurrentLocationContent);
        thisView.infowindow.setOptions({
          pixelOffset: new google.maps.Size(0, -10)
        });
        thisView.infowindow.open(thisView.map, thisView.currentLocationMarker);
      });

      input.addEventListener("change", () => {
        if (input.innerHTML.trim() === "") {
          thisView.resetSearchInput();
        }
      });

      const searchByPlace = function(place) {
        geocoder
          .geocode({ placeId: place.place_id })
          .then(({ results }) => {
            const newLocationCord = {lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
            thisView.$emit("onLocationCordChanged", newLocationCord);

            thisView.map.setZoom(SEARCH_ZOOM);
            thisView.map.setCenter(results[0].geometry.location);
            thisView.currentLocationMarker.setPlace({
              placeId: place.place_id,
              location: results[0].geometry.location,
            });
            thisView.currentLocationMarker.setVisible(true);
            thisView.infowindowCurrentLocationContent.children["place-name"].innerHTML = 'LOCATION';
            thisView.infowindowCurrentLocationContent.children["place-address"].innerHTML = results[0].formatted_address;
            thisView.infowindow.setContent(thisView.infowindowCurrentLocationContent);
            thisView.infowindow.setOptions({
              pixelOffset: new google.maps.Size(0, -10)
            });
          })
          .catch((e) => window.alert(`Geocoder failed due to: ${ e}`));
        };

      autocomplete.addListener("place_changed", () => {
        thisView.infowindow.close();

        const place = autocomplete.getPlace();

        if (!place.place_id) {
          thisView.resetSearchInput();
          return;
        }
        searchByPlace(place);

      });

      jQuery(input).on("keydown", function(e) {
        if (e.keyCode === 13 || e.keyCode === 9) {
          e.preventDefault();
          e.target.blur();
          let searchText = e.target.value;
          if (searchText === "") return;
          let firstResult = "";
          if (!searchText.includes(", UK")) {
            if(jQuery(".pac-container .pac-item:first span:eq(3)").text() === "") {
              firstResult = jQuery(".pac-container .pac-item:first .pac-item-query").text();
            } else {
              firstResult = `${jQuery(".pac-container .pac-item:first .pac-item-query").text() }, ${ jQuery(".pac-container .pac-item:first span:eq(3)").text()}`;
            }
          }
          if (firstResult === "") return;
          geocoder.geocode({"address":firstResult }, function(results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              const foundPlace = results[0];
              searchByPlace(foundPlace);
              e.target.value = firstResult;
            }
          });
        }
      });
      const submitButton = jQuery(input).siblings("button");
      submitButton.on("click", function(e) {
        e.preventDefault();
        let keydownEvent = jQuery.Event("keydown");
        keydownEvent.which = 13;
        keydownEvent.keyCode = 13;
        jQuery(input).trigger(keydownEvent);
      });
    },

    hideInfoWindowOnTappingOutside() {
      const thisView = this;
      google.maps.event.addListener(thisView.map, "click", function() {
        thisView.infowindow.close();
      });
    },

    resetSearchInput() {
      this.$emit("onLocationCordReset");
      if (this.currentLocationMarker) {
        this.currentLocationMarker.setVisible(false);
        this.currentLocationMarker.setPosition(null);
      }
      this.infowindow.close();
      this.map.setZoom(OVERALL_ZOOM);
      /*this.user_location_cord = this.save_user_location_cord;
      if (this.user_location_cord) {
        this.currentLocationMarker.setVisible(false);
        this.infowindow.close();
        this.map.setZoom(OVERALL_ZOOM);
      }*/
    },

    onAllPracticesChanged() {
      const the_practices = this.all_practices;
      if (this.markersPool && this.markersPool.length > 0) {
        const practice_ids_have_markers = this.markersPool.map(item => item.id);
        const total_new_practices = the_practices.filter(item => practice_ids_have_markers.indexOf(item.ad_location_id) < 0);
        if (total_new_practices.length > 0) {
          const new_markers = this.getMarkers(total_new_practices);
          if (this.markerClusterer) {
            this.markerClusterer.addMarkers(new_markers, false);
          }
        } else {
          const practice_loc_ids = the_practices.map(item => item.ad_location_id);
          const existed_markers = this.markersPool.filter(item => practice_loc_ids.indexOf(item.id) > -1);
          if (existed_markers && existed_markers.length > 0) {
            this.initMarkerClusterer(this.map, existed_markers.map(item => item.marker));
          }
        }
      } else {
        const new_markers = this.getMarkers(the_practices);
        this.initMarkerClusterer(this.map, new_markers);
      }

      if (this.active_practice) {
        const apractice = the_practices.filter(item => item.ad_location_id === this.active_practice.ad_location_id);
        if (!(apractice && apractice.length > 0)) {
          this.infowindow.close();
        }
      }
    }

  },

  mounted() {
    this.map = null;
    this.infowindow = null;
    this.infowindowPracticeLocationContent = null;
    this.infowindowCurrentLocationContent = null;
    this.currentLocationMarker= null;
    this.markersPool = [];
    this.markerClusterer = null;
    this.renderMap();
  },

  computed: {
    getSelectButtonLabel() {
      if (this.active_practice && this.active_practice.ID === this.appointment.practice.ID && this.active_practice.ID != 0) {
        return "Selected";
      } else if (this.active_practice && this.active_practice.has_next_appointment) {
        return "Select practice";
      }

      return "";
    },
    getActiveClass() {
      if (this.active_practice && this.active_practice.ID === this.appointment.practice.ID && this.active_practice.ID != 0) {
        return "active";
      } else if (this.active_practice && this.active_practice.has_next_appointment) {
        return "";
      }

      return "";
    }
  }

};
</script>

<style lang="postcss">
section {
  .location-map {
    @apply pt-[20px];

    .infowindow-current-location,
    .infowindow-practice-location {
      display: none;
    }

    .map {

      .gm-style {

        .gm-style-iw {
          @apply border-2 border-pink bg-pink-lighter !px-sm pt-sm w-[328px] h-auto overflow-visible;

          .gm-style-iw-d {
            @apply bg-pink-lighter !overflow-visible p-0;
          }
        }

        .gm-style-iw-tc {
          @apply opacity-0;
        }
      }

      .infowindow-current-location,
      .infowindow-practice-location {
        @apply max-w-full block;

        .button-wrapper {
          @apply bg-[#FFE2F7] w-auto -mx-[29px] px-[30px] py-[20px] rounded-b-lg;

          .btn {
            @apply w-full px-0 min-w-0;
          }
        }
      }

      .infowindow-current-location {
        @apply mb-[30px];

        &::before {
          @apply !bg-pink h-[42px] left-0 absolute -bottom-[22px] w-[42px];
          left: calc(50% - 21px);
          content: "";
          clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
          border-radius: 0 0 0 1.25em;
          transform: rotate(-45deg);
          backface-visibility: hidden;
        }

        &::after {
          @apply !bg-pink-lighter h-[40px] left-0 absolute -bottom-[19px] w-[40px];
          left: calc(50% - 20px);
          content: "";
          clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
          border-radius: 0 0 0 1em;
          transform: rotate(-45deg);
          backface-visibility: hidden;
        }

        #place-name,
        #place-address {
          @apply font-avenir-medium text-sm text-charcoal tracking-widest;
        }
      }

      .infowindow-practice-location {

        &::before {
          @apply !bg-pink h-[42px] left-0 absolute -bottom-[22px] w-[42px];
          left: calc(50% - 21px);
          content: "";
          clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
          border-radius: 0 0 0 1.25em;
          transform: rotate(-45deg);
          backface-visibility: hidden;
        }

        &::after {
          @apply bg-[#FFE2F7] h-[40px] left-0 absolute -bottom-[19px] w-[40px];
          left: calc(50% - 20px);
          content: "";
          clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
          border-radius: 0 0 0 1em;
          transform: rotate(-45deg);
          backface-visibility: hidden;
        }

        #place-name {
          @apply font-brandon-black text-body-xl tracking-widest text-navy uppercase mb-2 inline-block;
          word-break: break-word;
        }

        #place-address {
          @apply font-avenir-book text-base text-charcoal inline-block;
        }

        #place-xmilesaway {
          @apply w-auto py-4 text-[15px] text-[#446481] font-avenir-book;
        }

        #place-nextappointment {
          @apply bg-[#FFE2F7] w-auto -mx-[29px] px-[30px] pt-[18px] text-base text-[#072034] font-avenir-book;
        }
      }
    }
  }
}
</style>
